module.exports = __webpack_public_path__ + "f85b66d2f50c3597c3bfffa056a6dfe3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/new_alternatives .png
// module id = 1706
// module chunks = 0